import React from "react";
import PropTypes from "prop-types";
import IconButton from "@/components/IconButton";
import {
  CheckIcon,
  DeleteIcon,
  EditIcon,
  RestrictUserIcon,
} from "@/constant/imagePath";
import { STATUS, statusActions } from "@/constant/statusConstants";

function Actions({
  row,
  handleOnClickDelete,
  handleOnChangeStatus,
  handleOnClickEdit,
  enableStatus = true,
}) {
  const isActive = row.original.status === STATUS.ACTIVE;
  const statusActionMap = statusActions();
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      {enableStatus && (
        <IconButton
          icon={!isActive ? CheckIcon : RestrictUserIcon}
          borderColor={!isActive ? "#05A16D" : "#C96500"}
          fromColor={!isActive ? "#088D96" : "#E7A000"}
          toColor={!isActive ? "#19C38B" : "#C96500"}
          onClick={() => handleOnChangeStatus(row.original)}
          tooltipText={
            !isActive
              ? statusActionMap[STATUS.ACTIVE]
              : statusActionMap[STATUS.INACTIVE]
          }
        />
      )}
      <IconButton
        icon={EditIcon}
        borderColor="#E80E57"
        fromColor="#FF6060"
        toColor="#EC1060"
        onClick={() => handleOnClickEdit(row.original)}
        tooltipText="Edit"
      />
      <IconButton
        icon={DeleteIcon}
        borderColor="#610002"
        fromColor="#AE1C28"
        toColor="#780002"
        onClick={() => handleOnClickDelete(row.original)}
        tooltipText="Delete"
      />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.func.isRequired,
  handleOnChangeStatus: PropTypes.func.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
